export enum LiveLectureAccessModeEnum {
  SUBJECT_INCLUDED = "SUBJECT_INCLUDED",
  STANDALONE_PAID = "STANDALONE_PAID",
  PRIVATE = "PRIVATE",
}
